const map = {
	"./Adrenaline/description.txt": 23588,
	"./Adrenaline_Team_Play_DLC/description.txt": 52203,
	"./Alchemist/description.txt": 60801,
	"./Anachrony_Classic_Expansion_Pack/description.txt": 63763,
	"./Anachrony_Essential_Edition/description.txt": 15998,
	"./Anachrony_Exosuit_Minitaures_Set/description.txt": 8261,
	"./Anachrony_Fractures_Of_Time_Expansion/description.txt": 81318,
	"./Anachrony_Future_Imperfect_Expansion/description.txt": 20854,
	"./Astra/description.txt": 2994,
	"./Beer_&_Bread/description.txt": 68555,
	"./Between_Two_Castles_Of_Mad_King_Ludwig/description.txt": 58142,
	"./Beyond_The_Sun/description.txt": 67123,
	"./Boonlake/description.txt": 94318,
	"./Bunny_Bunny_Moose_Moose/description.txt": 92500,
	"./Bushido/description.txt": 87289,
	"./Cerebria_Forces_Of_Balance_Expansion/description.txt": 78642,
	"./Cerebria_The_Inside_World/description.txt": 15492,
	"./Champions_Of_Midgard/description.txt": 91392,
	"./Charterstone/description.txt": 5501,
	"./City_Of_Gears/description.txt": 35547,
	"./Codenames_Duet_XXL/description.txt": 24666,
	"./Coloretto/description.txt": 17636,
	"./Concordia_Aegyptus_Creta_Expansion/description.txt": 11668,
	"./Concordia_Balearica_Cyprus_Expansion/description.txt": 60863,
	"./Concordia_Gallia_Corsica_Expansion/description.txt": 20281,
	"./Concordia_Venus_Balearica_Italia_Expansion/description.txt": 68925,
	"./Cooper_Island/description.txt": 59179,
	"./Crystal_Palace/description.txt": 4496,
	"./Detective_Bullets_Over_Hollywood/description.txt": 84439,
	"./Detective_City_Of_Angels/description.txt": 60417,
	"./Detective_Smoke_And_Mirrors_Expansion/description.txt": 96003,
	"./Dive/description.txt": 84667,
	"./Dominion_Adventure/description.txt": 42965,
	"./Dominion_Alchemy/description.txt": 77504,
	"./Dominion_Allies/description.txt": 66527,
	"./Dominion_Dark_Ages/description.txt": 1794,
	"./Dominion_Empires/description.txt": 16590,
	"./Dominion_Guilds_&_Cornucopia/description.txt": 18834,
	"./Dominion_Hinterlands/description.txt": 88001,
	"./Dominion_Hinterlands_Update_Pack/description.txt": 16181,
	"./Dominion_Intrigue_Second_Edition/description.txt": 93190,
	"./Dominion_Menagerie/description.txt": 17090,
	"./Dominion_Nocturne/description.txt": 18235,
	"./Dominion_Prosperity/description.txt": 75314,
	"./Dominion_Prosperity_2nd_Ed_Update_Pack/description.txt": 12955,
	"./Dominion_Renaissance/description.txt": 21908,
	"./Dominion_Seaside/description.txt": 29589,
	"./Dominion_Seaside_Update_Pack/description.txt": 9257,
	"./Dragon_Land/description.txt": 4578,
	"./Dungeon_Lords/description.txt": 38598,
	"./Dungeon_Lords_Festival_Season/description.txt": 43803,
	"./Dungeon_Lords_Happy_Anniversary/description.txt": 69802,
	"./Dungeon_Petz/description.txt": 64971,
	"./Dungeon_Petz_Dark_Alleys/description.txt": 42751,
	"./Eko/description.txt": 3282,
	"./Euphoria_Build_A_Better_Dystopia_With_Gametrays/description.txt": 51873,
	"./Evergreen/description.txt": 14308,
	"./Final_Girl_Birds_Miniatures_Pack/description.txt": 25685,
	"./Final_Girl_Expansion_A_Knock_At_The_Door/description.txt": 91340,
	"./Final_Girl_Expansion_Carnage_At_The_Carnival/description.txt": 78439,
	"./Final_Girl_Expansion_Creech_Manor/description.txt": 59653,
	"./Final_Girl_Expansion_Frightmare_On_Maple_Lane/description.txt": 22397,
	"./Final_Girl_Expansion_Into_The_Void/description.txt": 97568,
	"./Final_Girl_Expansion_Madness_In_The_Dark/description.txt": 96589,
	"./Final_Girl_Expansion_Once_Upon_A_Full_Moon/description.txt": 8001,
	"./Final_Girl_Expansion_Panic_At_Station_2891/description.txt": 94566,
	"./Final_Girl_Expansion_Slaughter_In_The_Groves/description.txt": 85361,
	"./Final_Girl_Miniatures_Box_Series_1/description.txt": 83890,
	"./Final_Girl_Miniatures_Box_Series_2/description.txt": 11937,
	"./Final_Girl_Series_1_Bonus_Features_Box/description.txt": 60640,
	"./Final_Girl_Series_1_Game_Mat_Bundle/description.txt": 28975,
	"./Final_Girl_Series_1_Vehicle_Pack/description.txt": 88079,
	"./Final_Girl_Series_2_Bonus_Features_Box/description.txt": 97997,
	"./Final_Girl_Series_2_Game_Mat_Bundle/description.txt": 76640,
	"./Final_Girl_Series_2_Vehicle_Pack/description.txt": 1074,
	"./Final_Girl_Terror_From_Above_Vignette/description.txt": 25385,
	"./Final_Girl_Zombies_Miniatures_Pack/description.txt": 30988,
	"./Founders_Of_Teotihuacan/description.txt": 72737,
	"./Friedrich/description.txt": 13729,
	"./Frosthaven/description.txt": 47895,
	"./Gaia_Project/description.txt": 82269,
	"./Galaxy_Trucker_Another_Big_Expansion/description.txt": 43097,
	"./Galaxy_Trucker_Latest_Models/description.txt": 5871,
	"./Galaxy_Trucker_Missions/description.txt": 75192,
	"./Galaxy_Trucker_Relaunched_Edition/description.txt": 13519,
	"./Glenmore_2_Chronicles/description.txt": 77608,
	"./Glenmore_2_Chronicles_Pack_1-3/description.txt": 92918,
	"./Glenmore_2_Chronicles_Pack_4-5/description.txt": 54281,
	"./Glenmore_2_Highlands_Game/description.txt": 70073,
	"./Glenmore_2_Metal_Coins/description.txt": 54662,
	"./Glory_Islands/description.txt": 78533,
	"./Goblins_Inc/description.txt": 6188,
	"./Goths_Save_The_Queen/description.txt": 81293,
	"./Gravity_Superstar/description.txt": 72951,
	"./Hostage_Negotiator/description.txt": 21307,
	"./Hostage_Negotiator_Crime_Wave/description.txt": 89702,
	"./Imperial/description.txt": 9342,
	"./Imperial_2030/description.txt": 91768,
	"./Imperial_Steam/description.txt": 87159,
	"./La_Famiglia_The_Great_Mafia_War/description.txt": 24749,
	"./Last_Will/description.txt": 84590,
	"./Last_Will_Getting_Sacked/description.txt": 84073,
	"./Letter_Jam/description.txt": 28756,
	"./Lost_Ruins_Of_Arnak/description.txt": 77087,
	"./Magic_Maze/description.txt": 54956,
	"./Magic_Maze_Hidden_Roles/description.txt": 54327,
	"./Magic_Maze_Kids/description.txt": 1642,
	"./Magic_Maze_On_Mars/description.txt": 14352,
	"./Maracaibo/description.txt": 68474,
	"./Maracaibo_The_Uprising_Expansion/description.txt": 25056,
	"./Messina_1347/description.txt": 58299,
	"./My_Little_Scythe_Pie_In_The_Sky_Expansion/description.txt": 66562,
	"./New_York_Zoo/description.txt": 97380,
	"./Obsession_2nd_Edition/description.txt": 46,
	"./Obsession_Bundle/description.txt": 23905,
	"./Obsession_Promotional_Tiles/description.txt": 48771,
	"./Orleans/description.txt": 27507,
	"./Orleans_Invasion_Expansion/description.txt": 52655,
	"./Orleans_Trade_&_Intrigue_Expansion/description.txt": 89907,
	"./Pax_Pamir/description.txt": 99740,
	"./Pax_Pamir_Coins_In_Bag/description.txt": 90258,
	"./Power_Grid_Australia_India/description.txt": 99084,
	"./Power_Grid_Benelux_Central_Europe/description.txt": 4110,
	"./Power_Grid_Middle_East_South_Africa/description.txt": 92000,
	"./Power_Grid_Northern_Europe_UK_&_Ireland/description.txt": 53185,
	"./Power_Grid_Québec_Baden/description.txt": 71554,
	"./Power_Grid_Russia_Japan/description.txt": 89370,
	"./Power_Grid_The_New_Power_Plants_1/description.txt": 65033,
	"./Power_Grid_The_New_Power_Plants_2/description.txt": 32794,
	"./Power_Grid_The_Robots/description.txt": 22843,
	"./Praga_Caput_Regni/description.txt": 40072,
	"./Pulsar_2849/description.txt": 39156,
	"./Qwinto/description.txt": 10279,
	"./Race_For_The_Galaxy_Alien_Artifacts/description.txt": 78051,
	"./Race_For_The_Galaxy_Expansion_Brinkmanship/description.txt": 29180,
	"./Race_For_The_Galaxy_Xeno_Invasion/description.txt": 23596,
	"./Railroad_Ink_Blazing_Red_Edition/description.txt": 97665,
	"./Railroad_Ink_Challenge_Lush_Green_Edition/description.txt": 15578,
	"./Railroad_Ink_Challenge_Shining_Yellow_Edition/description.txt": 83837,
	"./Railroad_Ink_Deep_Blue_Edition/description.txt": 94813,
	"./Reavers_Of_Midgard/description.txt": 78330,
	"./Renature/description.txt": 83807,
	"./Renature_Valley_Expansion/description.txt": 85271,
	"./Roll_For_The_Galaxy/description.txt": 97265,
	"./Roll_For_The_Galaxy_Ambition/description.txt": 83721,
	"./Roll_For_The_Galaxy_Rivalry/description.txt": 27303,
	"./Rush_Out/description.txt": 3234,
	"./Sanctum/description.txt": 47624,
	"./Seven_Bridges/description.txt": 89085,
	"./Silver_&_Gold/description.txt": 53296,
	"./Similo_Harry_Potter/description.txt": 69574,
	"./Sound_Box/description.txt": 66290,
	"./Space_Alert/description.txt": 33816,
	"./Space_Alert_The_New_Frontier/description.txt": 53575,
	"./Space_Station_Phoenix/description.txt": 44986,
	"./Spirit_Island/description.txt": 21848,
	"./Spirit_Island_Expansion_Jagged_Earth/description.txt": 61804,
	"./Sushi_Dice/description.txt": 22885,
	"./TZAAR/description.txt": 44759,
	"./Tabannusi_Builders_Of_Ur/description.txt": 92313,
	"./Take_That/description.txt": 8126,
	"./Tapestry/description.txt": 86803,
	"./Tash-Kalar_Arena_Of_Legends/description.txt": 56700,
	"./Tash-Kalar_Everfrost/description.txt": 9828,
	"./Tawantinsuyu_The_Golden_Age/description.txt": 64121,
	"./Tawantinsuyu_The_Inca_Empire/description.txt": 58532,
	"./Tekhenu_Obelisk_Of_The_Sun/description.txt": 18334,
	"./Tekhenu_Time_Of_Seth/description.txt": 73796,
	"./Teotihuacan_City_Of_Gods/description.txt": 92586,
	"./Teotihuacan_Expansion_Period/description.txt": 80164,
	"./Teotihuacan_Late_Preclassic_Period/description.txt": 58823,
	"./Teotihuacan_Shadow_Of_Xitle/description.txt": 6070,
	"./Terra_Mystica/description.txt": 89386,
	"./Terra_Mystica_Automa_Solo_Box/description.txt": 75569,
	"./Terra_Mystica_Big_Box/description.txt": 17751,
	"./Terra_Mystica_Fire_&_Ice/description.txt": 20808,
	"./Terra_Mystica_Merchants_Of_The_Seas_Expansion/description.txt": 54181,
	"./Terra_Nova/description.txt": 31570,
	"./Terracotta_Army/description.txt": 68870,
	"./Thats_A_Question/description.txt": 31936,
	"./The_Game_Quick_And_Easy/description.txt": 3064,
	"./The_Game_West/description.txt": 20621,
	"./The_Great_Split/description.txt": 47811,
	"./The_Isle_Of_Cats_Late_Arrivals/description.txt": 25880,
	"./The_Kings_Dilemma/description.txt": 5311,
	"./The_Mind/description.txt": 54146,
	"./The_Mind_Exreme/description.txt": 64192,
	"./The_Princes_Of_Florence/description.txt": 55932,
	"./The_Prodigals_Club/description.txt": 61159,
	"./Through_The_Ages_A_New_Story_Of_Civilization/description.txt": 46238,
	"./Through_The_Ages_A_New_Story_Of_Civilization_New_Leaders_And_Wonders/description.txt": 32065,
	"./Tiletum/description.txt": 39479,
	"./Tiny_Epic_Defenders/description.txt": 16186,
	"./Tiny_Epic_Defenders_The_Dark_War_Expansion_Deluxe_Edition/description.txt": 9637,
	"./Tiny_Epic_Dinosaurs/description.txt": 91902,
	"./Tiny_Epic_Dinosaurs_Official_Game_Mat/description.txt": 75516,
	"./Tiny_Epic_Galaxies/description.txt": 26560,
	"./Tiny_Epic_Galaxies_Blast_Off/description.txt": 97381,
	"./Tiny_Epic_Galaxies_Official_Play_Mat/description.txt": 58290,
	"./Tiny_Epic_Kingdoms_Heroes_Call_Expansion/description.txt": 67110,
	"./Tiny_Epic_Mechs/description.txt": 51388,
	"./Tiny_Epic_Pirates/description.txt": 12496,
	"./Tiny_Epic_Pirates_Curse_Of_Amdiak_Expansion/description.txt": 80897,
	"./Tiny_Epic_Quest/description.txt": 26464,
	"./Tiny_Epic_Tactics/description.txt": 94065,
	"./Tiny_Epic_Tactics_Official_Play_Mat/description.txt": 16127,
	"./Tiny_Epic_Western/description.txt": 88084,
	"./Trickerion_Dahlgaards_Academy_Expansion/description.txt": 71270,
	"./Trickerion_Dawn_Of_Technology_Expansion/description.txt": 80757,
	"./Trickerion_Legends_Of_Illusion/description.txt": 31054,
	"./Twenty_One/description.txt": 3775,
	"./Tzolk'in/description.txt": 23961,
	"./Tzolk'in_Tribes_&_Prophecies/description.txt": 95441,
	"./Ultra_Tiny_Epic_Kingdoms/description.txt": 87564,
	"./Underwater_Cities/description.txt": 56922,
	"./Underwater_Cities_New_Discoveries/description.txt": 27342,
	"./Upstairs_Downstairs/description.txt": 32363,
	"./Vadoran_Gardens/description.txt": 91653,
	"./Viticulture_Moor_Visitors_Expansion/description.txt": 81577,
	"./Wessex_Expansion/description.txt": 74125,
	"./Yspahan/description.txt": 95787,
	"./Zapotec/description.txt": 47129,
	"./Zoned_Out/description.txt": 94054
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98108;